import { autoinject } from "aurelia-framework";
import { RequestClientService, ResponseType } from "@rightship-tech/common-ui/services/basic/request-client.service";
import {Urls} from "../../constants/vessel-comparison/vessel-comparison.constants";
import { GetVesselDetailsResponse, GetVesselDetailsRequest, CreateVesselComparisonPdfRequest } from "../../models/vessel-comparison/vessel-comparison.models";

@autoinject()
export class VesselComparisonService {

    constructor(private requestClient: RequestClientService) {
    }
    
    public getVesselDetails(request: GetVesselDetailsRequest): Promise<GetVesselDetailsResponse> {
        return this.requestClient.get<GetVesselDetailsResponse>(`${Urls.GetVesselDetails}`, request);
    }
    
    public createVesselComparisonPdf(request: CreateVesselComparisonPdfRequest): Promise<void> {
        return this.requestClient.post<Blob>(`${Urls.CreateVesselComparisonPdf}`, {}, request, ResponseType.Blob).then(x => {
            this.requestClient.downloadFile(x, "Vessel Comparison" + ".pdf");
        }, e => { throw e; });
    }
}